import { Component, h } from '@stencil/core';

@Component({
  tag: 'curated-offers-skeleton',
  shadow: true,
  styleUrl: 'section-unbeateable-deals.scss'
})
export class CuratedOffersSkeleton {
  render() {
    return (
      <div class="p-4">
        {/* Header skeleton */}
        <div class="flex justify-between items-center pb-4">
          <skeleton-element class="h-5 w-1/3" />
          <skeleton-element class="h-4 w-4 rounded-full" />
        </div>

        {/* Horizontal skeleton cards */}
        <div class="flex gap-4 overflow-x-auto">
          {[...Array(3)].map((_, idx) => (
            <div key={idx} class="p-2 rounded-2xl bg-white shrink-0 w-full max-w-3xs flex flex-col shadow-xl" style={{ boxShadow: '0px 2px 16px 0px #0000001F' }}>
              <div class="relative">
                <skeleton-element class="h-28 w-full rounded-t-lg" />
                <div class="absolute left-2 -bottom-6">
                  <skeleton-element class="h-11 w-11 rounded-xl border-2 border-white bg-white" />
                </div>
              </div>
              <div class="relative pt-6">
                <skeleton-element class="h-3 w-2/3 mb-2" />
                <skeleton-element class="h-4 w-3/4" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
